import script from "./EditVehicleModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditVehicleModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditVehicleModal.vue?vue&type=style&index=0&id=54a1cb3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a1cb3c"]])

export default __exports__